import { Stack } from '@mui/material';
import { PropsWithChildren } from 'react';

import { IconProps } from '@/global/types/common.type';

export interface IconWrapperProps extends PropsWithChildren<IconProps> {
  width?: string | number;
  height?: string | number;
}

const IconWrapper = ({ children, color = 'white', size = 24, width, height }: IconWrapperProps) => {
  const w = width || size;
  const h = height || size;

  return (
    <Stack width={`${w}px`} height={`${h}px`} alignItems={'center'} justifyContent={'center'} color={color}>
      {children}
    </Stack>
  );
};

export default IconWrapper;
